import { offcardReportQuerySchema } from '@chukua/common';
import { useListQuery } from '../../../../../shared/hooks/use-list-query';
import { usePagedList } from '../../../../../shared/hooks/use-paged-list';
import { listOffcardReport } from '../../../rate-cards.api';

/** The page of the off-card report the URL's list query asks for. */
export function useOffcardReport() {
  const list = useListQuery(offcardReportQuerySchema);
  return { list, ...usePagedList(list.query, listOffcardReport) };
}
